import type { FaireProductEntity } from "../../entity_types/product";

export const p_br35xyuc45: FaireProductEntity = {
  token: "p_br35xyuc45",
  type: "product",
  name: "Preorder-Stretch duppioni asymmetrical collar dress - S27065",
  brandToken: "b_69c3hdlc0m",
  brandName: "SAMUEL DONG",
  imageUrl:
    "https://cdn.faire.com/fastly/6afc17558bd12fa04f35b93158fa5ad2829b587f421998af699510f247b0e2f4.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/849a4a424ac7064df3253f4aa026267cacb8530badc47c5b1edaafb7a83f1fc9.png",
    "https://cdn.faire.com/fastly/0c6ecc684a373423fa6484ad16ba5f1a4ee6e89905ea7d4bfad7ccecdc5077d9.jpeg",
    "https://cdn.faire.com/fastly/e697338d37575aa1166b400c3bc732eb2c229693179ec597f8c594ac5803dc17.png",
    "https://cdn.faire.com/fastly/aae8c585f93164ffeb91e8b62588e79fd5fdd0cb39eee33b055429a42cca9ed2.jpeg",
    "https://cdn.faire.com/fastly/2b1fb778dbf1e7e1a0cbb5499e0c6f1dce12ea63aaa28d18794e9b5ed0c3d715.jpeg",
    "https://cdn.faire.com/fastly/4f3c3f6ee6d19f19b4d5befd0658da67fdb3481ec3513136625e1b5cb465574c.jpeg",
    "https://cdn.faire.com/fastly/cab70199c4dff1ec284f5190baa2882df02b229db1d316fe23cd17ba6d4f6651.jpeg",
    "https://cdn.faire.com/fastly/0b2ebf6cf04bf931be4763db31cb19e3ad49777d74b44b5eb8ddf9939a7b1c01.jpeg",
    "https://cdn.faire.com/fastly/5b6513ed3173662a29bcc828c5b6078cbab9b899ff70e3814955c4bfe623386e.jpeg",
    "https://cdn.faire.com/fastly/5a3d49a571c12a5b724f3c894487c3c2728395536ea6ccab764737cad1d57349.jpeg",
    "https://cdn.faire.com/fastly/02b9c31f1b3a98364fe6a1b4340d97de09a31d0ed849bbc4bd2dbc066ff867e8.jpeg",
    "https://cdn.faire.com/fastly/90e96ec2751e2f2491c481041100963f813e6ef1b1e2ce6c70561847087340e2.jpeg",
    "https://cdn.faire.com/fastly/e409175d7aa7532b33e9f7f6f56fe0bdf32d1127609dc4d7e324e3da0405198a.jpeg",
  ],
  priceDollars: 129,
  description:
    "Spring 2027 New Collection\n\nStretch duppioni fully lined A-line long dress, side pockets, 2 trimming wired pocket lids, hidden zipper with trimming buttons front, back hem slit, asymmetrical collars.",
  tags: [],
  msrpDollars: 389,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:11.147Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
